import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import PaymentOtherContent from './PaymentOtherContent';

export default function PaymentOther() {
  return (
    <CasinoContainer title={'Other payment settings'}>
      <PaymentOtherContent />
    </CasinoContainer>
  );
}
